export const PAGES_GENERATOR = {
    EDIT_AGENT_PROFILE: function (loginId?: string): string {
        return `/agent/${loginId?.toLowerCase() || ':loginId'}/edit`;
    }
}

export const PAGES = {
    HOME: '/',
    HOME_WITH_LANG: '/en',
    LOGIN: '/login',
    FORGOT_USERNAME: 'forgot-username',
    FORGOT_PASSWORD: 'forgot-password',
    MY_PROFILE: '/me',
    EDIT_PROFILE: '/edit-profile',
    ADD_AGENT_PROFILE: '/agent/add',
    POST_LOGIN: '/post-login',
    MANAGE_AGENTS: '/agent/manage',
    PENDING_REQUESTS: '/agent/pending-requests',
    ACCESS_DENIED: '/403',
    EDIT_AGENT_PROFILE: PAGES_GENERATOR.EDIT_AGENT_PROFILE()
};

export const knownPages = Object.values(PAGES);